import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Button from "../../../../../../ui/Button";
import Progress from "../../../../../../ui/Progress";
import { SmallStateIcon, StateTextColor } from "../../components/StateStyles";
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import { getProgram } from "../../store/actions";
import InfoDrawer from "../../../../../../ui/InfoDrawer";
import ImageBox from "../../../../../../ui/InfoDrawer/components/ImageBox";
import TitleField from "../../../../../../ui/InfoDrawer/components/TitleField";
import DeviderLine from "../../../../../../ui/InfoDrawer/components/DeviderLine";
import StateBlock from "../../../../../../ui/InfoDrawer/components/StateBlock";
import {getStateTextColor, StateName} from "../../../../../../Study/Groups/components/StateStyles";
import InfoField from "../../../../../../ui/InfoDrawer/components/InfoField";

const drawerWidth = 280;

const useStyles = makeStyles(theme => ({
  more: {
    marginTop: 24,
    marginBottom: 90,
    display: "flex",
    justifyContent: "center"
  },
  progress: {
    display: "flex",
    justifyContent: "center"
  }
}));

const ProgramInfoDrawer = ({
  open,
  programId,
  history,
  hideLink,
  linkConstructor,
  programCard,
  getProgram
}) => {
  const classes = useStyles();

  React.useEffect(() => {
    if (programId !== -1) {
      getProgram(programId);
    }
  }, [programId]);

  const onLinkClick = () => {
    history.push(`/work/app/manage/resources/programs/myprograms/${programCard.id}`);
  };

  const onLinkConstructorClick = () => {
    history.push(`/work/app/constructor/edit-program/${programCard.id}`);
  };

  return (
    <InfoDrawer open={open}>
      {programCard ? <>
          <ImageBox type="programs" image={programCard.logo}/>
          <TitleField title={programCard.name}/>
          <StateBlock leftChipLabel={`${programCard.duration || 0} ч.`}
                      leftChipBackground="rgba(48,73,103,0.8)"
                      leftChipIcon={<AccessTimeIcon />}
                      rightChipLabel={programCard.statusName}
                      rightChipBackground={StateTextColor(programCard.statusId)}
                      rightChipIcon={SmallStateIcon(programCard.statusId, "svgIcon svgFillWhite")}/>
          <DeviderLine/>
          <InfoField name="Профессия" value={programCard.specName || '-'} display={"block"}/>
          <InfoField name="Компетенция" value={programCard.skillName || '-'} display={"block"}/>
          <InfoField name="Квалификационный разряд" value={programCard.qualification || '-'} display={"block"}/>
          <InfoField name="Форма обучения" value={programCard.educationFormName || '-'} display={"block"}/>
          <InfoField name="Форма аттестации" value={programCard.trialFormName || '-'} display={"block"}/>
          <InfoField name="Категория слушателей" value={programCard.targetName || '-'} display={"block"}/>
          <DeviderLine/>
          <div className={classes.more}>
            {!hideLink && <Button onClick={onLinkClick}>Подробнее</Button>}
          </div>
       </> :
        <div className={classes.progress}>
          <Progress/>
        </div>
      }
    </InfoDrawer>
  );
};

const mapStateToProps = state => ({
  programCard:  state.programs.programCard
});

const mapDispatchToProps = dispatch => ({
  getProgram: id => dispatch(getProgram(id))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ProgramInfoDrawer));
